module.exports = "/_next/static/images/811e26a50ccee25e845eab19168e0cfd-people-working-together@lg-1x.jpg.webp";